import { Either, Left, Right } from "@sniptt/monads";
import { Decoder, either } from "decoders";
import { canDecode } from "./decoders";

export function eitherDecoder<L, R>(leftDecoder: Decoder<L>, rightDecoder: Decoder<R>): Decoder<Either<L, R>> {
  return either(leftDecoder, rightDecoder).transform((result) =>
    canDecode(leftDecoder, result) ? Left(result as L) : Right(result as R)
  );
}
